export default [
    {label: 'FTT2', value: 'ftt2'},
    {label: 'TTT', value: 'ttt'}
]